/* eslint-disable import/no-cycle */
/* eslint-disable dot-notation */
import { graphql, Script } from 'gatsby'
import { useState, useEffect } from 'react'
import tw, { css } from 'twin.macro'
import { Global } from '@emotion/react'

// eslint-disable-next-line import/no-cycle
import Spinner from '@/icons/bwi/spinner.svg'
import { isPrint } from '@/utils/print'

export const fragment = graphql`
  fragment HubiloForm on ContentfulComponentHubiloForm {
    __typename
    id
    contentful_id
    node_locale
    formId
  }
`

export default function HubiloForm({ id, formId }: Queries.HubiloFormFragment): JSX.Element {
  const [loaded, setLoaded] = useState(false)
  useEffect(
    () => () => {
      // remove the style tag we had to apply when component unmounts
      if (!document.getElementById(targetId)) {
        document.getElementsByTagName('html')[0].removeAttribute('style')
      }
    },
    []
  )
  const targetId = `hbl-${id}`

  if (isPrint()) return null
  return (
    <div tw="min-h-[10rem]">
      {!loaded && (
        <div tw="w-full flex justify-center p-8">
          <Spinner tw="animate-spin h-16 w-16 text-gray-400" />
        </div>
      )}

      <div id={targetId}>
        <Script
          src="https://cdn.hubilo.com/ticketing/widget/static/js/ticketing-widget.js"
          onLoad={() => {
            setLoaded(true)
            // THIS IS A TERRIBLE HACK TO OVERIDE SOME TERRIBLE CSS FROM HULIO
            document.getElementsByTagName('html')[0].setAttribute('style', 'font-size: 16px !important')
            window['@hubilotechnologies/ticketing-micro-fe'].init({
              container: document.getElementById(targetId),
              props: {
                communityUrl: `https://events.hubilo.com/${formId}`,
                languageCode: 'EN',
                showEventInfo: false,
                hideEventLogo: false,
                hideEventSocialLinks: false,
                isWidgetExpand: true,
                environment: 'production',
              },
            })
          }}
        />
        <Global
          styles={css`
            #wrapperForWidget {
              ${tw`!bg-transparent`}
            }
            .singleViewWidgetInfo {
              ${tw`!bg-white`}
            }
            .MuiBox-root {
              ${tw`!font-body !font-normal !text-lg`}
            }
            .MuiBox-root:before,
            .MuiBox-root:after {
              ${tw`!left-[-100000000000px]`}
            }
            .MuiPaper-root.MuiPaper-outlined {
              ${tw`!border-0`}
            }
            .MuiPaper-root.MuiPaper-outlined > div {
              ${tw`!p-0`}
            }
            .ticketPrice {
              ${tw`!pt-5`}
            }

            .continueBtn {
              ${tw`!bg-none`}
            }
            button.MuiButton-contained,
            button.MuiButton-sizeLarge {
              ${tw`!bg-primaryBlue text-white rounded-4xl text-lg py-4 px-5 !h-auto`}
            }
            button.MuiButton-contained:hover,
            button.MuiButton-sizeLarge:hover {
              ${tw`!bg-indigoBlue shadow-none`}
            }
            button.MuiButton-contained:disabled {
              ${tw`!bg-gray-300`}
            }
            label.MuiTypography-caption,
            .MuiTypography-root span > a,
            .css-4t7phx,
            .policyForReg p a {
              ${tw`!text-indigoBlue`}
            }

            .MuiContainer-maxWidthLg > div {
              ${tw`rounded-4xl bg-white !p-10`}
            }
            .MuiTextField-root > div input.MuiOutlinedInput-input {
              ${tw`!text-lg md:!text-lg !px-4 !py-4 !bg-white`}
            }
            .MuiContainer-root .MuiInputBase-input {
              ${tw`!px-4 !py-4 !bg-white !text-lg`}
            }
            .MuiFormControl-root > p {
              ${tw`!text-sm font-normal`}
            }
            .MuiContainer-root .MuiInputBase-root:hover fieldset {
              ${tw`!border-gray-400 !text-lg`}
            }

            .MuiSvgIcon-root {
              ${tw`!text-primaryBlue`}
            }
            .MuiFormControlLabel-root {
              ${tw`!border-0`}
            }
            .Mui-error {
              ${tw`!text-red-500 !text-base`}
            }

            .MuiBox-root .MuiTypography-h2.css-ud3rxv,
            .MuiBox-root .MuiTypography-body2 {
              ${tw`!font-body !font-normal !text-2xl`}
            }
            .MuiBox-root p {
              ${tw`!font-body`}
            }
            .widgetWithSimRegFlowWrapper {
              ${tw`!pb-10`}
            }

            @media screen and (max-width: 480px) {
              .singleViewWrapperWidget {
                ${tw`!p-0`}
              }
            }
          `}
        />
      </div>
    </div>
  )
}
